import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetNumberYearsAttendedAsm, GetNumberYearsAttendedAsmResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetNumberYearsAttendedAsmResponse, GetNumberYearsAttendedAsmResponse>) => response?.data?.yearsAttended;

const getError = (response?: SWRResponse<GetNumberYearsAttendedAsmResponse, GetNumberYearsAttendedAsmResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetNumberYearsAttendedAsmResponse, GetNumberYearsAttendedAsmResponse>) => ({
    yearsAttended: response?.data?.yearsAttended,
    yearsAttendedId : response?.data?.yearlyAttendanceId
});

export const useAttendanceStatus = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }

        return () => {
            return new GetNumberYearsAttendedAsm({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useAttendanceStatus;
